<template>
    <div>
    <v-row>
      <v-col sm="4" cols="3">
        <v-text-field
          v-model="filterItems.textFilter"
          label="Prozessname"
          clearable
          @keyup="applyTextFilter"
          @click:clear="resetTextFilter()"
          prepend-inner-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-btn text color="secondary" @click="showFilterOptions = !showFilterOptions">
        <v-icon left>
        mdi-filter-multiple-outline
        </v-icon>
        Filteroptionen   <v-chip color="secondary" v-if="nonEmptyFilterCount">{{nonEmptyFilterCount}}</v-chip>
      </v-btn>
    </v-row>
    
    <v-card elevation="1" style="margin-bottom:2px" v-if="showFilterOptions">
      
    <v-row style="margin:10px" v-if="loading == false">
      <v-col v-if="contextItems.systems.length > 0">
        <v-select
        class="filterField"
        v-model="filterItems.systemFilter"
        dense
        :items="contextItems.systems"
        item-value="id"
        item-text="name"
        chips
        hide-details
        label="System"
        multiple>
        <template v-slot:selection="{data, index}">
          <v-chip v-if="index === 0" color="secondary">
            <span>{{filterItems.systemFilter.length}}</span>
          </v-chip>
        </template>
      </v-select>
      </v-col>
      <v-col v-if="contextItems.roles.length > 0">
        <v-select
        dense
        v-model="filterItems.roleFilter"
        :items="contextItems.roles"
        item-value="id"
        item-text="name"
        chips
        hide-details
        label="Rolle"
        multiple
      >
        <template v-slot:selection="{data, index}">
          <v-chip v-if="index === 0" color="secondary">
            <span>{{filterItems.roleFilter.length}}</span>
          </v-chip>
        </template>
      </v-select>
      </v-col>
      <v-col v-if="contextItems.departments.length > 0" >
        <v-select
        v-model="filterItems.departmentFilter"
        dense
        :items="contextItems.departments"
        item-value="id"
        item-text="name"
        chips
        hide-details
        label="Abteilung"
        multiple
      >
        <template v-slot:selection="{data, index}">
          <v-chip v-if="index === 0" color="secondary">
            <span>{{filterItems.departmentFilter.length}}</span>
          </v-chip>
        </template>
      </v-select>
      </v-col>
      <v-col v-if="characteristicPresent">
        <v-select
        v-model="filterItems.processTypeFilter"
        dense
        :items="processType"
        item-value="name"
        item-text="name"
        chips
        hide-details
        label="Prozessart"
        multiple
      >
        <template v-slot:selection="{data, index}">
          <v-chip v-if="index === 0" color="secondary">
            <span>{{filterItems.processTypeFilter.length}}</span>
          </v-chip>
        </template>
      </v-select>
      </v-col>
      <v-col cols="4" align="right">
        <v-btn color="secondary" density="compact" @click="applyFilter()" size="small">
           <v-icon>mdi-check</v-icon>Anwenden
        </v-btn>
        <v-btn style="margin-left:10px" color="secondary" text medium elevation="0" @click="resetFilter()">
           Zurücksetzen
        </v-btn>
      </v-col>
      
    </v-row>
      <div style="padding:10px">
        <v-chip 
          color="secondary" label>Systemfilter:</v-chip><span
          v-for="val in filterValues"
          :key="'A'+val.id"
          
        >
        <v-chip v-if="val.key == 'System'" class="ma-2"
          color="primary"
          label
          outlined>
          {{ val.name }}
        </v-chip>
           
      </span>
      <v-chip 
          color="secondary" label>Rollenfilter:</v-chip><span
          v-for="val in filterValues"
          :key="'B'+val.id"
          
        >
        <v-chip v-if="val.key == 'Rolle'" class="ma-2"
          color="primary"
          label
          outlined>
          {{ val.name }}
        </v-chip>
           
      </span>
      <v-chip label
          color="secondary">Abteilungsfilter:</v-chip><span
          v-for="val in filterValues"
          :key="'C'+val.id"
          
        >
        <v-chip v-if="val.key == 'Abteilung'" class="ma-2"
          color="primary"
          label
          outlined>
          {{ val.name }}
        </v-chip>
           
      </span>
      <v-chip label
          color="secondary">Prozessartfilter:</v-chip><span
          v-for="val in filterValues"
          :key="'D'+val.id"

        >
        <v-chip v-if="val.key == 'Prozessart'" class="ma-2"
          color="primary"
          label
          outlined>
          {{ val.name }}
        </v-chip>
           
      </span>
      </div>
    </v-card>
</div>
</template>

<script>
import connectedRessourceService from '@/pages/ProcessModeling/CustomModelingTools/ConnectedRessources/connectedRessourceService.js'
export default {
    props:["characteristicPresent"],
    name: "FilterComponent",
    data() {
      return {
        filterItems:{
          systemFilter: [],
          roleFilter: [],
          departmentFilter:[],
          textFilter:"",
          processTypeFilter: []
        },
        contextItems:{
            systems: [],
            departments: [],
            roles: []
        },
        processType: [
          {name: "Kernprozess", value: "CORE"},
          {name: "Führungsprozess", value:"LEADERSHIP"},
          {name: "Unterstützungsprozess", value:"SUPPORT"}
        ],
        loading: true,
        showFilterOptions: false
      };
    },
    computed:{
      filterValues(){
        let combinedFilters = [];
        // Iterate over each filter and map it to key-value pairs
        Object.entries(this.filterItems).forEach(([filterKey, filterValue]) => {
            let contextKey = '';
            switch(filterKey) {
                case 'systemFilter':
                    contextKey = 'System';
                    break;
                case 'departmentFilter':
                    contextKey = 'Abteilung';
                    break;
                case 'roleFilter':
                    contextKey = 'Rolle';
                    break;
                default:
                    break;
            }
            if (contextKey !== '') {
                combinedFilters.push(...filterValue.map(id => {
                    let item = this.contextItems[filterKey.slice(0, -6) + 's'].find(contextItem => contextItem.id === id);
                    return { key: contextKey, id, name: item ? item.name : null };
                }));
            }
        });
        combinedFilters.push(...this.filterItems.processTypeFilter.map(value => {
            return { key: "Prozessart", id: value, name: value };
        }));
        return combinedFilters;
      },
      nonEmptyFilterCount(){
       return Object.values(this.filterItems)
        .filter(item => Array.isArray(item) && item != this.filterItems.contextFilter) // Filter only arrays
        .flat().length
      }
    },
    mounted() {
      this.getFilters();
    },
    methods: {
      getFilters(){
        connectedRessourceService.retrieveConnectedRessources().then((res) => {
          let departments = res.data.filter(elem => elem.type == "DEPARTMENT");
          let systems = res.data.filter(elem => elem.type == "SYSTEM");
          let roles = res.data.filter(elem => elem.type == "ROLE");
          this.contextItems = {
            systems: systems,
            departments: departments,
            roles: roles
          }
          this.loading = false;
        })
      },
      async applyFilter(){
        this.filterItems.contextFilter = [];
        this.filterItems.contextFilter = Object.values(this.filterItems).filter(elem => Array.isArray(elem) && elem != this.filterItems.processTypeFilter).flat();
        this.$emit("applyFilter", this.filterItems);
      },
      resetTextFilter(){
        this.filterItems.textFilter = "";
        this.filterItems.isResetText = true;
        this.applyTextFilter();
      },
      applyTextFilter(){
        this.$emit("applyTextFilter", this.filterItems);
        this.applyFilter();
      },
      resetFilter(){
        this.filterItems = {
          systemFilter: [],
          roleFilter: [],
          departmentFilter:[],
          textFilter:"",
          processTypeFilter: []
        }
        this.$emit("resetFilter", this.filterItems);
      }
    }
  };
</script>